import { observer } from 'mobx-react-lite'

import {
  FACEBOOK_URL,
  REGISTRATION_NOT_YET_OPEN,
  REGISTRATION_OPEN_DATE_LABEL,
  RESULT_DATE,
  WEBSITE_LABEL,
  WEBSITE_URL,
} from '../utils/const'
import AuthStore from '../stores/auth'
import { SectionHeading } from '@/components/ds/SectionHeading'
import { StatusPage, inkLinkClassName } from '@/components/ds/StatusPage'
import { Button } from '@/components/ui/button'

function RegistrationClosed() {
  const authStore = AuthStore

  return (
    <StatusPage>
      <SectionHeading
        level={1}
        th={
          REGISTRATION_NOT_YET_OPEN
            ? 'ยังไม่เปิดรับสมัคร'
            : 'ระบบปิดรับสมัครแล้ว'
        }
        en={
          REGISTRATION_NOT_YET_OPEN
            ? 'Registration not open yet'
            : 'Registration closed'
        }
      />
      {REGISTRATION_NOT_YET_OPEN ? (
        <p className="ds-body mt-6 text-ink-body">
          ระบบจะเปิดรับสมัครในวันที่{' '}
          <span className="font-semibold text-ink">
            {REGISTRATION_OPEN_DATE_LABEL}
          </span>
        </p>
      ) : (
        <p className="ds-body mt-6 text-ink-body">
          โปรดรอประกาศผลการรับสมัครบนเว็บไซต์{' '}
          <a
            href={WEBSITE_URL}
            target="_blank"
            rel="noreferrer"
            className={inkLinkClassName}
          >
            {WEBSITE_LABEL}
          </a>{' '}
          ในวันที่ <span className="font-semibold text-ink">{RESULT_DATE}</span>
        </p>
      )}
      <p className="ds-body mt-3 text-ink-body">
        ติดตามข่าวสารและสอบถามข้อมูลเพิ่มเติมได้ทาง{' '}
        <a
          href={FACEBOOK_URL}
          target="_blank"
          rel="noreferrer"
          className={inkLinkClassName}
        >
          Facebook Page
        </a>
      </p>
      {!!authStore.userId && (
        <Button
          variant="ghost"
          className="mt-8"
          onClick={() => authStore.doLogout()}
        >
          ออกจากระบบ
        </Button>
      )}
    </StatusPage>
  )
}

export default observer(RegistrationClosed)
